import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppService, ColorPickerService, CoreProxyService, CoreTypes, IncidentsService, IncidentTypes, LabelValue, Modal, StringDateTimePipe } from 'common-cloudstudio';
import { GearAppService } from 'common-gear';
import moment from 'moment';
import { forkJoin, Subscription } from 'rxjs';
import { IncidentService } from '../../services/incident.service';

@Component({
  selector: 'app-communications',
  templateUrl: './communications.component.html',
  styleUrls: ['./communications.component.scss']
})
export class CommunicationsComponent implements OnInit, OnDestroy {
  @ViewChild('communicationModal') private _communicationModal: Modal;

  incidentID: number = 0;
  communicationID: number = 0;
  selectedRowList: any[] = [];
  hasAssociatedEvents: boolean = false;
  allHaveAssociatedEvents: boolean = false;
  noneHaveAssociatedEvents: boolean = false;
  generalActions = [
    { Icon: 'fa-solid fa-magnifying-glass', Tooltip: 'Ver registro', Action: (row) => this.onEdit(row?.CommunicationID) },
  ]
  columnsConfig = [
    { Title: 'ID', Field: 'CommunicationID', Type: 'text', Width: 50 },
    { Title: 'Fecha y Hora', Field: 'DateTimeCreated', Type: 'text', Alignment: 2},
    { Title: 'Emisor', Field: 'Issuer', Type: 'text'},
    { Title: 'Eje', Field: 'VialAxis', Type: 'text'},
    { Title: 'PK', Field: 'PK', Type: 'text'},
    { Title: 'Calzada', Field: 'TrafficDirection', Type: 'text'},
    { Title: 'Descripción', Field: 'Description', Type: 'text', MaxWidthPixels: 185 },
    { Title: 'Comunicado', Field: 'PressRelease', Type: 'text', MaxWidthPixels: 175 },
    { Title: 'Evento', Field: 'Events', Type: 'dynamic'},
    { Title: 'Tipo Evento', Field: 'IncidentType', Type: 'text'},
    { Title: 'Detalle Evento', Field: 'IncidentSubType', Type: 'text', MaxWidthPixels: 185},
    { Title: '', Field: 'Actions', Type: 'actions' }
  ]

  _params: any[] = [
    {
      "AllowedValues": null,
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": null,
      "ParameterID": 3,
      "ParameterType": 1,
      "Prompt": "ID Comunicado",
      "RefreshOnChange": false,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": null,
      "ValueDateEndExpression": null,
      "ValueDateStart": null,
      "ValueDateStartExpression": null,
      "ValueMultiString": null,
      "ValueNumber": '',
      "ValueString": null
    },
    {
      "AllowedValues": null,
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": null,
      "ParameterID": 3,
      "ParameterType": 1,
      "Prompt": "ID Evento",
      "RefreshOnChange": false,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": null,
      "ValueDateEndExpression": null,
      "ValueDateStart": null,
      "ValueDateStartExpression": null,
      "ValueMultiString": null,
      "ValueNumber": '',
      "ValueString": null
    },
    {
      "AllowedValues": null,
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": null,
      "ParameterID": 3,
      "ParameterType": 1,
      "Prompt": "Correlativo",
      "RefreshOnChange": false,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": null,
      "ValueDateEndExpression": null,
      "ValueDateStart": null,
      "ValueDateStartExpression": null,
      "ValueMultiString": null,
      "ValueNumber": '',
      "ValueString": null
    },
    {
      "AllowedValues": null,
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": null,
      "ParameterID": 1,
      "ParameterType": 9,
      "Prompt": "Período",
      "RefreshOnChange": false,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": {
        "Date": {
          "Day": 12,
          "Month": 7,
          "Year": 2024
        },
        "Time": {
          "Hour": 22,
          "Millisecond": 0,
          "Minute": 33,
          "Second": 22
        }
      },
      "ValueDateEndExpression": "",
      "ValueDateStart": {
        "Date": {
          "Day": 11,
          "Month": 7,
          "Year": 2024
        },
        "Time": {
          "Hour": 0,
          "Millisecond": 0,
          "Minute": 0,
          "Second": 0
        }
      },
      "ValueDateStartExpression": "",
      "ValueMultiString": null,
      "ValueNumber": 0,
      "ValueString": null
    },
    {
      "AllowedValues": [
        {
          "Name": "Tipo evento",
          "Value": "556"
        },
        {
          "Name": "Tipo evento ",
          "Value": "560"
        }
      ],
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": null,
      "ParameterID": 9999,
      "ParameterType": 2,
      "Prompt": "Tipo Evento",
      "RefreshOnChange": true,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": null,
      "ValueDateEndExpression": null,
      "ValueDateStart": null,
      "ValueDateStartExpression": null,
      "ValueMultiString": null,
      "ValueNumber": 0,
      "ValueString": "556"
    },
    {
      "AllowedValues": [
        {
          "Name": "Tipo comunicado Bitácora",
          "Value": "556"
        },
        {
          "Name": "Tipo comunicado",
          "Value": "560"
        }
      ],
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": null,
      "ParameterID": 9999,
      "ParameterType": 2,
      "Prompt": "Tipo comunicado",
      "RefreshOnChange": true,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": null,
      "ValueDateEndExpression": null,
      "ValueDateStart": null,
      "ValueDateStartExpression": null,
      "ValueMultiString": null,
      "ValueNumber": 0,
      "ValueString": "556"
    }
  ]
  _vialAxesFullList: CoreTypes.ITS_VialAxes[];
  _trafficDirectionsFullList:CoreTypes.ITS_TrafficDirection[] = [];
  _colorsFullList:CoreTypes.InternalColor[] = [];
  _incidentTypeFullList:CoreTypes.IncidentType[] = [];
  _incidentSubTypeFullList:CoreTypes.IncidentSubType[] = [];
  _communicationIssuerFullList: CoreTypes.ITS_CommunicationIssuers[] = [];
  _communicationIssuerList: LabelValue<any>[] = [];
  _communicationTypesFullList: CoreTypes.ITS_CommunicationTypes[] = [];


  communicationElements: IncidentTypes.IncidentElementModal;
  incidentManagementTypes = IncidentTypes.IncidentManagementType;
  menuFilterButtonList: LabelValue<number>[] = [
    { label: 'Crear Evento', value: this.incidentManagementTypes.Incidents, icon: 'fa-plus' },
    { label: 'Asociar Evento', value: this.incidentManagementTypes.AssociateIncident, icon: 'fa-link' },
    { label: 'Desasociar Evento', value: this.incidentManagementTypes.DisassociateIncident, icon: 'fa-link-slash' },
  ];
  
  menuTableButtonList: LabelValue<number>[] = [
    { label: 'Todos', value: 1 },
    { label: 'Ninguno', value: 2 },
    { label: 'Sin evento', value: 3 },
    { label: 'Con evento', value: 4 },
  ];
  loadCommunication = 0;
  _facilityID: number = 0;
  subscriptions: Subscription[] = [];
  tableConfig: {
    Columns: any[],
    Elements: any[]
  };

  constructor(
    public appService: AppService,
    private cdRef:ChangeDetectorRef,
    private coreProxyService: CoreProxyService,
    private _gearService: GearAppService,
    private stringDateTimePipe: StringDateTimePipe,
    private incidentService: IncidentService,
    private incidetServices: IncidentsService,
    private colorService: ColorPickerService,
    public gearAppService: GearAppService,
  ) {}

  async ngOnInit() {
    this.tableConfig = await this.generateDynamicTableWithActions(this.columnsConfig, []);
    if (this.appService.CoreCommonLiterals && this.gearAppService.GearMonitorLiterals) {
      this.loadData();
    }

    this.subscriptions.push(this.gearAppService.onLiteralsSet.subscribe(() => {
      this.loadData();
    }));

    this._facilityID = this.appService.getFacilityID();
    this.subscriptions.push(this._gearService.onChangeFacilityID.subscribe(facilityID => {
      if (this._facilityID === facilityID) { return; }
      this._facilityID = this.appService.getFacilityID();
      this.tableConfig = null;
      this.loadData();
    }));

    this.subscriptions.push(this.incidentService.onRefreshCommunicationList.subscribe(refresh => {
      if(refresh) {
        this.loadData();
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  loadData() {
    forkJoin([
      this.getGearPermission()
    ])
    .subscribe({
      complete: async () => {
        this.getCommunications();
      }
    });
  }

  getGearPermission() {
    return new Promise((resolve, reject) => {
      this.gearAppService.onGearPermissionList.subscribe(permissions => {
        if(!permissions) return;
        resolve(permissions);
      },
      error => {
        reject(error);
      })
    });
  }

  getCommunications() {
    this.loadCommunication = 1;
    if(this.tableConfig?.Elements?.length) this.tableConfig.Elements = [];
    this.coreProxyService.IncidentService.EnumITSCommunications(
      this.appService.getAccessToken(),
      this.appService.getClientID(),
      this.appService.getFacilityID(),
      async data => {
        if(data.length) { await this.loadRequiredLists(); }
        this.tableConfig = this.generateDynamicTableWithActions(this.columnsConfig, data);
        this.loadCommunication = 0;
      },
      async err => {
        this.appService.showException(err);
        this.loadCommunication = 2;
      }
    );
  }

  async loadRequiredLists() {
    if (!this._vialAxesFullList?.length) await this.getVialAxis();
    if (!this._trafficDirectionsFullList?.length) await this.getTrafficDirection();
    if (!this._communicationIssuerFullList?.length) await this.getCommunicationIssuers();
    if (!this._communicationTypesFullList?.length) await this.getCommunicationTypes();
    if (!this._colorsFullList?.length) await this.getITSColors();
    if (!this._incidentTypeFullList?.length) await this.getITSIncidentType();
    if (!this._incidentSubTypeFullList?.length) await this.getIncidentSubTypes();
  }

  async getVialAxis() {
    this._vialAxesFullList = await this.incidentService.getITSVialAxes();
  }
  
  async getTrafficDirection() {
    await this.incidentService.getITSTrafficDirections();
    this._trafficDirectionsFullList = await this.incidentService._trafficDirectionsList.value;
  }

  async getITSColors() {
    this._colorsFullList = await this.incidetServices.getColorsAllowedForIncidents(this.appService.getClientID());
  }

  async getITSIncidentType() {
    this._incidentTypeFullList = await this.incidentService.getIncidentTypes();
  }

  async getIncidentSubTypes() {
    this._incidentSubTypeFullList = await this.incidentService.getIncidentubTypes();
  }

  async getCommunicationIssuers() {
    let parameters: CoreTypes.ITS_CommunicationIssuerParameters = new CoreTypes.ITS_CommunicationIssuerParameters();
    parameters.IncludeEmergencyVehicles = true;
    parameters.IncludeIssuers = true;
    parameters.IncludeServices = true;
    parameters.IncludeVehicles = true;
    this._communicationIssuerFullList = await this.incidentService.getCommunicationIssuers(parameters);
    this._communicationIssuerList =  await this.incidentService._issuersList.value;
  }

  async getCommunicationTypes() {
    this._communicationTypesFullList = await this.incidentService.getITSCommunicationTypes();
  }
  
  generateDynamicTableWithActions(columnsConfig: any[], data: any) {
    return {
      Columns: columnsConfig.map(col => ({
        Title: col.Title,
        Field: col.Field,
        Type: col.Type,
        Alignment: col.Alignment || 0,
        WidthPixels: col.Width || 100,
        MaxWidthPixels: col.MaxWidthPixels || null
      })),
      Elements: this.getIncidentWithActions(data)
    };
  }
  
  getIncidentWithActions(communications: CoreTypes.ITS_Communication[], enableRowActions?:boolean): any[]{
    if (!communications?.length) { return []; }
    return communications.map((element) => {
      const issuer = this._communicationIssuerList?.find(rp => +rp.value.split('-')[0] === element.CommunicationIssuerID);
      const vialAxes = this._vialAxesFullList?.find(v => v.VialAxisID === element?.VialAxisID);
      const type = this._communicationTypesFullList.find(c => c.CommunicationTypeID == element?.CommunicationType);
      const findColor = this._colorsFullList?.find(c => c.ColorID === element.ColorID)?.ColorCode;
      const communicationColor = findColor ? this.colorService.rgbToHexa((findColor)) : null;
      const trafficDirection = this._trafficDirectionsFullList?.find(t => t.DirectionID ===  element?.TrafficDirectionID);
      const eventType = this._incidentTypeFullList?.find(t => t.IncidentTypeID ===  element?.Type);
      const subType = this._incidentSubTypeFullList?.find(t => t.IncidentSubTypeID ===  element?.SubType);

      return {
        Enabled: false,
        ElementId: element.CommunicationID,
        CommunicationID: element.CommunicationID,
        DateTimeCreated: moment(this.stringDateTimePipe.transform(element.DateTimeCreated)).format('DD-MM-YYYY HH:mm'),
        Issuer: issuer?.label,
        VialAxis: vialAxes?.VialAxisName,
        PK: element?.KilometerPoint,
        TrafficDirection: trafficDirection?.DirectionName,
        Description: type?.CommunicationTypeName,
        PressRelease: element.Description,
        Events: element.IncidentID ? {
          Type: 'icon-text',
          Text: element.IncidentID,
          EventID: element.IncidentID,
          Icons: [
            { Icon: 'fa-solid fa-list', Tooltip: 'Ver evento', Action: (row) => this.onViewIncident(row?.Events?.EventID) },
            { Icon: 'fa fa-ambulance', Tooltip: 'Ver ficha de emergencia', Action: (row) => this.onViewEmergencySheet(row) }
          
          ]
        } : {
          Type: 'icon-text',
          Text: 'Sin evento',
          EventID: element.IncidentID,
        },
        IncidentType: eventType?.Description,
        IncidentSubType: subType?.SubtypeName,
        Actions: [
          {
            Icon: 'fa-solid fa-magnifying-glass',
            Tooltip: 'Ver Detalles',
            Action: () => this.onEdit(element.CommunicationID)
          }
        ],
        RowStyle: { backgroundColor: communicationColor }
      };
    });
  }

  addNewEvent() {
    this.communicationID = this.selectedRowList[0].CommunicationID;
    this.communicationElements = {
      IncidentElementTypeID: this.incidentManagementTypes.Incidents,
      JsonData: '',
      Editing: false,
      IncidentID: 0,
      CommunicationIDs: [this.communicationID]
    }
    this.cdRef.detectChanges();
    this._communicationModal.open(this.communicationElements);
  }

  onEdit(communicationID) {
    this.communicationID = communicationID;
    this.communicationElements = {
      IncidentElementTypeID: this.incidentManagementTypes.Communications,
      JsonData: '',
      Editing: true,
      IncidentID: 0,
      CommunicationIDs: [this.communicationID]
    }
    this.cdRef.detectChanges();
    this._communicationModal.open(this.communicationElements);
  }

  onAssociateIncident(id, check) {
    let index = this.selectedRowList?.findIndex(x => x === id);
    check && index < 0 ? this.selectedRowList.push(id) : this.selectedRowList?.splice(index, 1)
  }

  onViewIncident(id) { 
    this.incidentID = id;
    this.communicationElements = {
      IncidentElementTypeID: this.incidentManagementTypes.Incidents,
      JsonData: '',
      Editing: true,
      IncidentID: this.incidentID
    }
    this.cdRef.detectChanges();
    this._communicationModal.open(this.communicationElements);
  }

  onViewEmergencySheet(row) { 
    this.incidentID = row.Events.EventID;
    this.communicationElements = {
      IncidentElementTypeID: this.incidentManagementTypes.IncidentFile,
      JsonData: '',
      Editing: false,
      IncidentID: this.incidentID
    };
    this.cdRef.detectChanges();
    this._communicationModal.open(this.communicationElements);
   }

  saveDataElements(event) {
    console.log(event);
    
  }

  onCloseSettings(event) {
    setTimeout(() => this.communicationElements = null, 100);
  }

  createStatement() {
    this.communicationElements = {
      IncidentElementTypeID: this.incidentManagementTypes.Communications,
      JsonData: '',
      Editing: false,
      IncidentID: 0,
      CommunicationIDs: []
    }
    this.cdRef.detectChanges();
    this._communicationModal.open(this.communicationElements);
  }

  actionEvents(event?) {
    if(event.value == this.incidentManagementTypes.AssociateIncident){
      let comunicationIDs = this.selectedRowList.map(x => x.CommunicationID);
      this.communicationElements = {
        IncidentElementTypeID: event.value ,
        JsonData: '',
        Editing: false,
        IncidentID: 0,
        CommunicationIDs: comunicationIDs
      }
      this.cdRef.detectChanges();
      this._communicationModal.open(this.communicationElements);
    } else if(event.value == this.incidentManagementTypes.Incidents) {
      this.addNewEvent();
    }
  }

  rowSelectedList(event) {
    this.selectedRowList = event;
    this.updateSelectionState(this.selectedRowList);
    
  }

  updateSelectionState(selectedItems: any[], allItems?: any[]): void {
    this.hasAssociatedEvents = selectedItems.some(item => item['Events']?.EventID);
    this.allHaveAssociatedEvents = selectedItems.every(item => item['Events']?.EventID);
    this.noneHaveAssociatedEvents = selectedItems.every(item => !item['Events']?.EventID);
    this.menuFilterButtonList[0].disabled = this.hasAssociatedEvents;
    this.menuFilterButtonList[1].disabled = this.hasAssociatedEvents;
    this.menuFilterButtonList[2].disabled = !this.allHaveAssociatedEvents;
  }
}
